
<div class="command-palette-wrapper">
    <ninja-keys
        ref="ninjaKeys"
        :data="commands"
        :placeholder="placeholder"
        :openHotkey="openHotkey"
        :closeHotkey="closeHotkey"
        @change="handleChange"
        @selected="handleSelected"
    />

    <!-- EntityDetailsModal is rendered via portal in App.vue -->
    <EntityDetailsModal
        :is-open="showEntityModal"
        :entity-type="selectedEntityType"
        :entity-id="selectedEntityId"
        :entity-name="selectedEntityName"
        :entity-subtitle="selectedEntitySubtitle"
        :entity-data="selectedEntityData"
        :revenue="entityStats.revenue"
        :days-worked="entityStats.daysWorked"
        :euro-per-km="entityStats.euroPerKm"
        :hours-worked="entityStats.hoursWorked"
        @close="handleCloseEntityModal"
    />
</div>
